/* ─────────────────────────────────────────────────────────────────────────
   Shared inspo gallery + favorites logic.
   Loaded by main-inspo (mode:'gallery') and main-my-inspo (mode:'saved').
   Config comes from window.INSPO_CONFIG = { mode, canFave }.
   Worker/customer auth is read from the global window.TALISNAILZ.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  var CFG = { mode: 'gallery', canFave: false };
  var favedIds = new Set();
  var submitFiles = [];

  function grid() { return document.getElementById('inspo-grid'); }
  function el(id) { return document.getElementById(id); }

  function workerPost(path, body) {
    var tn = window.TALISNAILZ || {};
    return fetch(tn.workerUrl + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ customerId: tn.customerId, ts: tn.authTs, sig: tn.authSig }, body))
    }).then(function (r) { return r.json(); });
  }

  function fmtTime(s) {
    var m = Math.floor(s / 60), sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  /* ── Modals ─────────────────────────────────────────────────────────── */
  window.inspoOpenSigninModal = function () {
    el('inspo-signin-modal').classList.add('is-open');
    document.body.classList.add('inspo-signin-modal-open');
  };
  window.inspoCloseSigninModal = function () {
    el('inspo-signin-modal').classList.remove('is-open');
    document.body.classList.remove('inspo-signin-modal-open');
  };
  window.inspoFavBtnClick = function (e) {
    if (!CFG.canFave) { e.preventDefault(); window.inspoOpenSigninModal(); }
  };
  window.inspoOpenSubmitModal = function () {
    if (!CFG.canFave) { window.inspoOpenSigninModal(); return; }
    el('inspo-submit-modal').classList.add('is-open');
    document.body.classList.add('inspo-submit-modal-open');
  };
  function updateSubmitButton() {
    var b = el('inspo-submit-btn');
    if (!b) return;
    b.disabled = !submitFiles.length;
    b.textContent = submitFiles.length
      ? 'Send ' + submitFiles.length + ' photo' + (submitFiles.length > 1 ? 's' : '') + ' ✦'
      : 'Add photos to send';
  }
  function renderSubmitThumbs() {
    var container = el('inspo-submit-thumbs');
    var dropZone = el('inspo-submit-drop');
    if (!container) return;
    container.innerHTML = submitFiles.map(function (f, i) {
      return '<div class="inspo-submit-thumb" onclick="event.stopPropagation();openInspoSubmitLightbox(' + i + ')"><img src="' + URL.createObjectURL(f) + '" alt=""></div>';
    }).join('');
    if (dropZone) dropZone.classList.toggle('has-photos', submitFiles.length > 0);
  }
  window.inspoCloseSubmitModal = function () {
    el('inspo-submit-modal').classList.remove('is-open');
    document.body.classList.remove('inspo-submit-modal-open');
    submitFiles = [];
    renderSubmitThumbs();
    updateSubmitButton();
    var s = el('inspo-submit-status'); if (s) s.textContent = '';
    var inp = el('inspo-submit-input'); if (inp) inp.value = '';
  };
  window.inspoSubmitHandleFiles = function (fileList) {
    var newFiles = Array.from(fileList).filter(function (f) { return f.type.startsWith('image/'); });
    submitFiles = submitFiles.concat(newFiles);
    renderSubmitThumbs();
    updateSubmitButton();
    var inp = el('inspo-submit-input'); if (inp) inp.value = '';
    var lb = el('inspo-submit-lightbox');
    if (lb && lb.classList.contains('is-open') && submitFiles.length) {
      buildInspoSubmitLightboxTrack();
      renderInspoSubmitLightbox(submitFiles.length - 1, true);
    }
  };
  window.inspoSubmitPhotos = async function () {
    var b = el('inspo-submit-btn'), s = el('inspo-submit-status');
    if (!submitFiles.length) return;
    if (b) { b.disabled = true; b.textContent = 'Uploading…'; }
    var tn = window.TALISNAILZ || {};
    var safeName = (tn.profileName || tn.customerName || tn.customerEmail || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'unknown';
    var folder = 'talisnailz/' + safeName + '/inspo-gallery';
    var total = submitFiles.length, failed = 0;
    for (var i = 0; i < total; i++) {
      if (b) b.textContent = 'Uploading ' + (i + 1) + ' of ' + total + '…';
      try { await window.CloudinaryUpload.upload(submitFiles[i], null, folder); } catch (e) { failed++; }
    }
    submitFiles = [];
    renderSubmitThumbs();
    var inp = el('inspo-submit-input'); if (inp) inp.value = '';
    if (b) { b.disabled = true; b.textContent = 'Add photos to send'; }
    if (s) s.textContent = failed
      ? (total - failed) + ' sent ✦ ' + failed + ' failed — try again'
      : 'Got them ✦ Tali will review your photos!';
  };

  /* ── Submit-modal lightbox: view / add more / trash a not-yet-sent photo ──
     Mirrors nail-scratch.js's scratch-lightbox carousel (same CSS classes,
     same infinite-loop clone-slide technique) since submitFiles are local
     File objects, not yet uploaded — trash here just drops the array entry. */
  var submitLbIndex = 0;

  function buildInspoSubmitLightboxTrack() {
    var track = el('inspo-submit-lightbox-track');
    var dotsWrap = el('inspo-submit-lightbox-dots');
    if (!track || !dotsWrap) return;
    var urls = submitFiles.map(function (f) { return URL.createObjectURL(f); });
    var html = '';
    if (urls.length > 1) html += '<div class="scratch-lightbox__slide" aria-hidden="true"><img src="' + urls[urls.length - 1] + '" alt="" onclick="event.stopPropagation()"></div>';
    urls.forEach(function (u) {
      html += '<div class="scratch-lightbox__slide"><img src="' + u + '" alt="" onclick="event.stopPropagation()"></div>';
    });
    if (urls.length > 1) html += '<div class="scratch-lightbox__slide" aria-hidden="true"><img src="' + urls[0] + '" alt="" onclick="event.stopPropagation()"></div>';
    track.innerHTML = html;
    dotsWrap.innerHTML = urls.map(function (_, i) {
      return '<span onclick="event.stopPropagation();inspoSubmitLightboxDot(' + i + ')"></span>';
    }).join('');
    dotsWrap.style.display = urls.length > 1 ? '' : 'none';
    document.querySelectorAll('#inspo-submit-lightbox .scratch-lightbox__arrow').forEach(function (a) {
      a.style.display = urls.length > 1 ? '' : 'none';
    });
  }

  function renderInspoSubmitLightbox(idx, instant) {
    var track = el('inspo-submit-lightbox-track');
    var dots = document.querySelectorAll('#inspo-submit-lightbox-dots span');
    var count = submitFiles.length;
    if (!track || count === 0) return;
    var hasClones = track.children.length === count + 2;
    var offset = hasClones ? 1 : 0;
    idx = ((idx % count) + count) % count;
    var trackPos = idx + offset;
    if (instant) {
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (trackPos * 100) + '%)';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { track.style.transition = ''; });
      });
    } else {
      track.style.transform = 'translateX(-' + (trackPos * 100) + '%)';
    }
    submitLbIndex = idx;
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
  }

  window.inspoSubmitLightboxNav = function (dir) {
    var track = el('inspo-submit-lightbox-track');
    var count = submitFiles.length;
    if (!track || count < 2) return;
    var hasClones = track.children.length === count + 2;
    var cur = submitLbIndex;

    if (hasClones && dir === 1 && cur === count - 1) {
      track.style.transform = 'translateX(-' + ((count + 1) * 100) + '%)';
      submitLbIndex = 0;
      document.querySelectorAll('#inspo-submit-lightbox-dots span').forEach(function (d, i) { d.classList.toggle('is-active', i === 0); });
      var onEnd1 = function () {
        track.removeEventListener('transitionend', onEnd1);
        track.style.transition = 'none';
        track.style.transform = 'translateX(-100%)';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { track.style.transition = ''; });
        });
      };
      track.addEventListener('transitionend', onEnd1);
      return;
    }
    if (hasClones && dir === -1 && cur === 0) {
      track.style.transform = 'translateX(0%)';
      submitLbIndex = count - 1;
      document.querySelectorAll('#inspo-submit-lightbox-dots span').forEach(function (d, i) { d.classList.toggle('is-active', i === count - 1); });
      var onEnd2 = function () {
        track.removeEventListener('transitionend', onEnd2);
        track.style.transition = 'none';
        track.style.transform = 'translateX(-' + (count * 100) + '%)';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { track.style.transition = ''; });
        });
      };
      track.addEventListener('transitionend', onEnd2);
      return;
    }
    renderInspoSubmitLightbox(cur + dir, false);
  };

  window.inspoSubmitLightboxDot = function (target) {
    renderInspoSubmitLightbox(target, true);
  };

  window.openInspoSubmitLightbox = function (startIdx) {
    if (!submitFiles.length) return;
    buildInspoSubmitLightboxTrack();
    renderInspoSubmitLightbox(startIdx || 0, true);
    var lb = el('inspo-submit-lightbox');
    if (lb) lb.classList.add('is-open');
    document.body.classList.add('scratch-lightbox-open');
  };

  window.closeInspoSubmitLightbox = function (e) {
    if (e) e.stopPropagation();
    var lb = el('inspo-submit-lightbox');
    if (lb) lb.classList.remove('is-open');
    document.body.classList.remove('scratch-lightbox-open');
  };

  window.inspoSubmitLightboxTrash = function () {
    if (!submitFiles.length) return;
    submitFiles.splice(submitLbIndex, 1);
    renderSubmitThumbs();
    updateSubmitButton();
    if (!submitFiles.length) {
      window.closeInspoSubmitLightbox();
      return;
    }
    var nextIdx = submitLbIndex >= submitFiles.length ? submitFiles.length - 1 : submitLbIndex;
    buildInspoSubmitLightboxTrack();
    renderInspoSubmitLightbox(nextIdx, true);
  };

  /* ── Favorites (gallery = toggle+heart · saved = remove tile) ────────── */
  window.inspoIsFaved = function (id) { return CFG.mode === 'saved' ? true : favedIds.has(String(id)); };
  window.inspoApplyFaveState = function (tile, faved) {
    var heart = tile.querySelector('.inspo__heart');
    if (heart) { heart.classList.toggle('is-faved', faved); heart.setAttribute('aria-pressed', faved); }
    if (window.inspoLightboxTile === tile) {
      var lbHeart = el('inspo-lightbox-heart');
      if (lbHeart) { lbHeart.classList.toggle('is-faved', faved); lbHeart.setAttribute('aria-pressed', faved); }
    }
  };
  // Serialized reconcile: one request in flight per tile, toggling the server until it matches
  // the tile's latest desired state. Because /toggle is order-sensitive, this (not response
  // reconciliation) is what makes rapid heart/unheart correct. The heart never follows a response.
  function syncFave(tile) {
    if (tile._faveSyncing) return;
    tile._faveSyncing = true;
    var isVid = tile.dataset.type === 'video';
    var photo = {
      id: tile.dataset.photoId,
      url: tile.dataset.full || tile.dataset.preview || '',
      alt: tile.dataset.alt,
      link: tile.dataset.link || '',
      type: isVid ? 'video' : 'photo',
      poster: isVid ? tile.dataset.preview : undefined,
      videoSrc: isVid ? tile.dataset.videoSrc : undefined
    };
    (async function () {
      try {
        while (tile._faveServer !== tile._faveDesired) {
          var data = await workerPost('/api/favorites/toggle', { blockId: tile.dataset.photoId, photo: photo });
          if (!data || !data.ok) break;
          tile._faveServer = !!data.faved;
        }
      } catch (e) {}
      tile._faveSyncing = false;
      // A click may have landed in the gap between the last check and clearing the flag.
      if (tile._faveServer !== tile._faveDesired) syncFave(tile);
    })();
  }

  window.inspoToggleFave = async function (tile) {
    if (!tile) return;
    if (!CFG.canFave) { window.inspoOpenSigninModal(); return; }
    if (CFG.mode === 'saved') {
      window.inspoCloseLightbox();
      tile.remove();
      if (!document.querySelector('#inspo-grid .inspo__tile')) showEmptyState();
      try {
        await workerPost('/api/favorites/toggle', {
          blockId: tile.dataset.photoId,
          photo: { id: tile.dataset.photoId, url: tile.dataset.full, alt: tile.dataset.alt, link: '' }
        });
      } catch (e) {}
      return;
    }
    var key = String(tile.dataset.photoId);
    // Capture the true server state once, before any optimistic mutation.
    if (tile._faveServer == null) tile._faveServer = favedIds.has(key);
    // Flip the shown state and update the heart instantly (UI is purely optimistic).
    var shown = (tile._faveDesired != null) ? tile._faveDesired : favedIds.has(key);
    var desired = !shown;
    tile._faveDesired = desired;
    if (desired) favedIds.add(key); else favedIds.delete(key);
    window.inspoApplyFaveState(tile, desired);
    // Drive the server to the desired state in the background.
    syncFave(tile);
  };
  function loadFavorites() {
    if (!CFG.canFave || !(window.TALISNAILZ || {}).workerUrl) return Promise.resolve();
    return workerPost('/api/favorites/list', {}).then(function (data) {
      if (data.ok && data.favorites) {
        favedIds = new Set(data.favorites.map(function (f) { return String(f.blockId); }));
        document.querySelectorAll('#inspo-grid .inspo__tile').forEach(function (tile) {
          window.inspoApplyFaveState(tile, favedIds.has(String(tile.dataset.photoId)));
        });
      }
    }).catch(function () {});
  }

  /* ── Saved-page tiles ───────────────────────────────────────────────── */
  function showEmptyState() {
    grid().innerHTML =
      '<div style="grid-column:1/-1;text-align:center;padding:32px 16px;color:var(--tn-pink-700)">' +
      '<p style="font-size:16px">You haven\'t saved any favorites yet.</p>' +
      '<a href="/pages/inspo-gallery" class="btn btn--outline" style="margin-top:16px">Browse the Inspo Gallery</a></div>';
  }
  function buildTile(photo) {
    var d = document.createElement('div');
    var isVideo = photo.type === 'video' && photo.videoSrc;
    d.className = 'inspo__tile' + (isVideo ? ' inspo__tile--video' : '');
    d.dataset.photoId = photo.blockId;
    d.dataset.full = photo.url;
    d.dataset.alt = photo.alt || '';
    d.dataset.link = photo.link || '';
    if (isVideo) { d.dataset.type = 'video'; d.dataset.preview = photo.poster || photo.url; d.dataset.videoSrc = photo.videoSrc; }
    var altEsc = (photo.alt || '').replace(/"/g, '&quot;');
    var mediaHtml;
    if (isVideo) {
      var posterUrl = (photo.poster || photo.url).replace(/"/g, '&quot;');
      var srcUrl = photo.videoSrc.replace(/"/g, '&quot;');
      mediaHtml =
        '<video class="inspo__video" muted playsinline preload="metadata" loop poster="' + posterUrl + '" onclick="inspoOpenLightbox(this.closest(\'.inspo__tile\'))">' +
        '<source src="' + srcUrl + '"></video>' +
        '<img class="inspo__video-poster" src="' + posterUrl + '" alt="' + altEsc + '" loading="lazy" onclick="inspoOpenLightbox(this.closest(\'.inspo__tile\'))">' +
        '<div class="inspo__video-time"></div>';
    } else {
      mediaHtml = '<img src="' + photo.url.replace(/"/g, '&quot;') + '" alt="' + altEsc + '" loading="lazy" onclick="inspoOpenLightbox(this.closest(\'.inspo__tile\'))">';
    }
    d.innerHTML = mediaHtml +
      '<button type="button" class="inspo__heart is-faved" aria-label="Remove from favorites" aria-pressed="true" onclick="event.stopPropagation();inspoToggleFave(this.closest(\'.inspo__tile\'))">' +
      '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M12 21s-7.5-4.6-10-9.3C.6 8.1 2.2 4 6 4c2.1 0 3.6 1.1 4.5 2.6L12 8.5l1.5-1.9C14.4 5.1 15.9 4 18 4c3.8 0 5.4 4.1 4 7.7-2.5 4.7-10 9.3-10 9.3z"/></svg></button>';
    return d;
  }

  /* ── Masonry (P8-fixed: reads width/height attrs, no pop-in) ─────────── */
  function layoutGrid(g) {
    g = g || grid();
    if (!g) return;
    var cs = getComputedStyle(g);
    var rowHeight = parseFloat(cs.getPropertyValue('grid-auto-rows')) || 8;
    var gap = parseFloat(cs.getPropertyValue('row-gap') || cs.getPropertyValue('gap')) || 16;
    var tiles = g.querySelectorAll('.inspo__tile');
    var spans = [];
    tiles.forEach(function (tile) {
      var img = tile.querySelector('img');
      var width = tile.getBoundingClientRect().width;
      var vid = tile.querySelector('.inspo__video');
      var iw = img ? (parseFloat(img.getAttribute('width')) || img.naturalWidth) : 0;
      var ih = img ? (parseFloat(img.getAttribute('height')) || img.naturalHeight) : 0;
      var naturalH = (iw && ih) ? (width * ih / iw)
        : (vid && vid.videoWidth) ? (width * vid.videoHeight / vid.videoWidth)
        : tile.getBoundingClientRect().height;
      spans.push(Math.ceil((naturalH + gap) / (rowHeight + gap)));
    });
    tiles.forEach(function (tile, i) { tile.style.gridRowEnd = 'span ' + spans[i]; });
  }
  var rafPending = false;
  function scheduleLayout() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () { rafPending = false; layoutGrid(grid()); });
  }
  function layoutAfterImages(g) {
    var imgs = g.querySelectorAll('img');
    var remaining = imgs.length;
    imgs.forEach(function (img) {
      if (img.complete) { if (--remaining <= 0) layoutGrid(g); }
      else img.addEventListener('load', function () { if (--remaining <= 0) layoutGrid(g); });
    });
    layoutGrid(g);
  }

  /* ── Video tiles (hover preview + time readout) ─────────────────────── */
  function initVideoTiles(container) {
    container.querySelectorAll('.inspo__tile--video').forEach(function (tile) {
      var vid = tile.querySelector('.inspo__video');
      var poster = tile.querySelector('.inspo__video-poster');
      var timeEl = tile.querySelector('.inspo__video-time');
      if (!vid) return;
      tile.addEventListener('mouseenter', function () { if (poster) poster.style.opacity = '0'; vid.play().catch(function () {}); });
      tile.addEventListener('mouseleave', function () { vid.pause(); if (poster) poster.style.opacity = ''; });
      vid.addEventListener('timeupdate', function () { if (timeEl) timeEl.textContent = fmtTime(vid.currentTime); });
      vid.addEventListener('loadedmetadata', function () { scheduleLayout(); });
    });
  }

  /* ── Lightbox (fixed: instant thumbnail/poster, no black flash) ─────── */
  window.inspoLightboxTile = null;
  window.inspoOpenLightbox = function (tile) {
    window.inspoLightboxTile = tile;
    var isVideo = tile.dataset.type === 'video';
    var lbImg = el('inspo-lightbox-img'), lbVid = el('inspo-lightbox-video'), lbTm = el('inspo-lightbox-time');
    if (isVideo) {
      var tileVid = tile.querySelector('.inspo__video');
      lbImg.style.display = 'none';
      lbVid.style.display = '';
      if (lbTm) lbTm.style.display = '';
      lbVid.poster = tile.dataset.preview || '';
      lbVid.setAttribute('preload', 'auto');
      lbVid.innerHTML = tileVid ? tileVid.innerHTML : '';
      lbVid.load();
      lbVid.addEventListener('canplay', function () { lbVid.play().catch(function () {}); }, { once: true });
    } else {
      lbImg.style.display = '';
      lbVid.style.display = 'none';
      if (lbTm) lbTm.style.display = 'none';
      if (!lbVid.paused) { lbVid.pause(); lbVid.currentTime = 0; }
      lbImg.alt = tile.dataset.alt;
      var lbThumb = tile.querySelector('img');
      var lbFull = tile.dataset.full;
      lbImg.src = (lbThumb && lbThumb.currentSrc) ? lbThumb.currentSrc : lbFull;
      if (lbFull) { var lbHi = new Image(); lbHi.onload = function () { lbImg.src = lbFull; }; lbHi.src = lbFull; }
    }
    var params = new URLSearchParams();
    params.set('inspo_photo', tile.dataset.full || tile.dataset.preview || '');
    params.set('inspo_alt', tile.dataset.alt);
    el('inspo-lightbox-cta').href = '/pages/nail-builder?' + params.toString();
    window.inspoApplyFaveState(tile, window.inspoIsFaved(tile.dataset.photoId));
    el('inspo-lightbox').classList.add('is-open');
    document.body.classList.add('inspo-lightbox-open');
  };
  window.inspoCloseLightbox = function () {
    var lbVid = el('inspo-lightbox-video');
    if (lbVid && !lbVid.paused) { lbVid.pause(); }
    el('inspo-lightbox').classList.remove('is-open');
    document.body.classList.remove('inspo-lightbox-open');
    window.inspoLightboxTile = null;
  };

  /* ── Init ───────────────────────────────────────────────────────────── */
  function migrateLegacyFavorites() {
    if (localStorage.getItem('tn_migrated_favorites')) return;
    var legacy = [];
    try { legacy = JSON.parse(localStorage.getItem('tn_inspo_favorites')) || []; } catch (e) {}
    if (!legacy.length) { localStorage.setItem('tn_migrated_favorites', '1'); return; }
    (async function () {
      for (var i = 0; i < legacy.length; i++) {
        var id = String(legacy[i]);
        if (!favedIds.has(id)) {
          var tile = document.querySelector('[data-photo-id="' + id + '"]');
          if (tile) try { await window.inspoToggleFave(tile); } catch (e) {}
        }
      }
      localStorage.setItem('tn_migrated_favorites', '1');
      localStorage.removeItem('tn_inspo_favorites');
    })();
  }

  function initSaved() {
    var tn = window.TALISNAILZ || {};
    var g = grid();
    if (!tn.customerId) {
      g.innerHTML =
        '<div style="grid-column:1/-1;text-align:center;padding:32px 16px;color:var(--tn-pink-700)">' +
        '<p style="font-size:16px">Sign in to see your saved nail looks ✦</p>' +
        '<a href="/customer_authentication/login?return_to=' + encodeURIComponent('/pages/my-inspo') + '" class="btn btn--primary" style="margin-top:16px;display:inline-block">Sign in</a></div>';
      return;
    }
    if (!tn.workerUrl) { showEmptyState(); return; }
    workerPost('/api/favorites/list', {}).then(function (data) {
      if (!data.ok || !data.favorites || !data.favorites.length) { showEmptyState(); return; }
      g.innerHTML = '';
      data.favorites.forEach(function (photo) { g.appendChild(buildTile(photo)); });
      initVideoTiles(g);
      layoutAfterImages(g);
    }).catch(function () { showEmptyState(); });
  }

  function init(opts) {
    Object.assign(CFG, opts || {});

    // Move overlays to <body> so they escape any transformed/overflow parents.
    ['inspo-lightbox', 'inspo-signin-modal', 'inspo-submit-modal'].forEach(function (id) {
      var n = el(id); if (n) document.body.appendChild(n);
    });

    // Lightbox video time readout.
    var lbVidEl = el('inspo-lightbox-video'), lbTimeEl = el('inspo-lightbox-time');
    if (lbVidEl && lbTimeEl) {
      lbVidEl.addEventListener('timeupdate', function () {
        lbTimeEl.textContent = fmtTime(lbVidEl.currentTime) + ' / ' + fmtTime(lbVidEl.duration || 0);
      });
    }

    // Esc/arrows close or navigate the topmost overlay. The submit-lightbox is
    // checked first so Escape only dismisses the photo viewer, not the whole
    // submit modal underneath it (which would also clear the selected photos).
    document.addEventListener('keydown', function (e) {
      var slb = el('inspo-submit-lightbox');
      if (slb && slb.classList.contains('is-open')) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); window.inspoSubmitLightboxNav(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); window.inspoSubmitLightboxNav(1); }
        else if (e.key === 'Escape') { window.closeInspoSubmitLightbox(); }
        return;
      }
      if (e.key === 'Escape') { window.inspoCloseLightbox(); window.inspoCloseSigninModal(); window.inspoCloseSubmitModal(); }
    });

    // Re-flow the masonry on resize.
    var g = grid();
    if (g) {
      if ('ResizeObserver' in window) { new ResizeObserver(scheduleLayout).observe(g); }
      else { window.addEventListener('resize', scheduleLayout); }
    }

    if (CFG.mode === 'saved') {
      initSaved();
    } else {
      initVideoTiles(g);
      layoutAfterImages(g);
      loadFavorites().then(migrateLegacyFavorites);
    }
  }

  // Deferred script → the DOM is already parsed when this runs.
  init(window.INSPO_CONFIG || {});
})();
